import { Zap } from "lucide-react";
import { Link } from "react-router-dom";

export function Brand({ to = "/", light = false, size = "md" }) {
  const dim = size === "lg" ? "h-11 w-11" : "h-9 w-9";
  const text = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <Link to={to} data-testid="brand-logo" className="flex items-center gap-2.5 group">
      <span className={`${dim} rounded-xl bg-brand grid place-items-center shadow-ambient group-hover:scale-105 transition-transform`}>
        <Zap className="h-5 w-5 text-white" strokeWidth={2.5} fill="white" />
      </span>
      <span className={`font-heading font-extrabold tracking-tight ${text} ${light ? "text-white" : "text-ink"}`}>
        Mock<span className="text-brand">2</span>Crack
      </span>
    </Link>
  );
}
